document.addEventListener('change', function (e) {
  const target = e.target;

  // Sirf color swatch radio inputs ke liye
  if (
    target.matches(
      'swatches-variant-picker-component input[type="radio"][data-variant-id]'
    )
  ) {
    const variantId = target.dataset.variantId;

    // Shopify product form ka hidden input
    const productForm = target.closest('swatches-variant-picker-component')
      ?.closest('section, product-card, .product')
      || document;

    const variantInput = productForm.querySelector(
      '.shopify-product-form .varaint_id_get_cstm'
    );

    if (variantInput && variantId) {
      variantInput.value = variantId;

      // Debug (optional)
      console.log('Selected Variant ID:', variantId);
    }
  }
});
function shareProduct() {
  const productUrl = window.location.href;
  const productTitle = document.querySelector('h1')?.innerText || document.title;

  if (navigator.share) {
    navigator.share({
      title: productTitle,
      url: productUrl
    });
  } else {
    navigator.clipboard.writeText(productUrl);
    alert("Product link copied!");
  }
}
